// @ts-strict-ignore
import { createReducer, on } from '@ngrx/store';
import * as VehicleFiltersActions from '../actions/vehicle-filters.actions';
import {
  FilterGroup,
  FilterItem,
} from '@fc-vehicles/components/shared/vehicle-filter/vehicles-filter.component';
import { changeSortByListOrder } from '@fc-shared/utils/change-sort-by-list-order';
import { SortBy } from '@fc-shared/ui/sort-by/sort-by';

const vehicleStatuses = [
  {
    color: '#19c98a',
    type: 'status',
    id: 'id_traveling',
    name: 'Traveling',
  },
  {
    color: '#afbec5',
    type: 'status',
    id: 'id_stopped',
    name: 'Stopped',
  },
  {
    color: '#ffc400',
    type: 'status',
    id: 'id_idling',
    name: 'Idling',
  },
  {
    color: '#25aaa2',
    type: 'status',
    id: 'id_towed',
    name: 'Towed',
  },
];

export const vehicleFiltersFeatureKey = 'core-vehicle-filters';

export type SearchBy = 'identifier' | 'vehicleInfo' | 'type' | 'operators';

export interface State {
  searchText: string;
  vehicleFilters: FilterGroup[];
  selectedFilters: FilterItem[];
  sortBy: SortBy;
  sortByList: SortBy[];
  searchFields: SearchBy[];
}

export const initialState: State = {
  vehicleFilters: null,
  selectedFilters: [],
  sortByList: [
    { name: 'Identifier', value: 'identifier', order: false },
    { name: 'Manufacturer', value: 'manufacturer', order: null },
    { name: 'Model', value: 'model', order: null },
    { name: 'Created', value: 'created', order: null },
    { name: 'Last Updated', value: 'last_updated', order: null },
  ],
  sortBy: { name: 'Identifier', value: 'identifier', order: false },
  searchText: '',
  searchFields: ['identifier', 'vehicleInfo', 'type'],
};

export const reducer = createReducer(
  initialState,
  on(VehicleFiltersActions.resetDefaultVehicleFilters, (state) => ({
    ...state,
    selectedFilters: [] as FilterItem[],
    sortBy: initialState.sortBy,
    sortByList: initialState.sortByList,
    searchText: '',
  })),
  on(VehicleFiltersActions.setSearchVehicleText, (state, action) => ({
    ...state,
    searchText: action.searchText,
  })),
  on(VehicleFiltersActions.setVehicleSortBy, (state, action) => ({
    ...state,
    sortBy: { ...action.sortBy, order: !action.sortBy.order },
    sortByList: changeSortByListOrder(state.sortByList, action.sortBy),
  })),
  on(VehicleFiltersActions.initVehicleFilters, (state, action) => ({
    ...state,
    vehicleFilters: state.vehicleFilters
      ? state.vehicleFilters
      : [
          {
            name: 'Types',
            filters: action.vehicleTypes.map((type) => ({
              ...type,
              type: 'type',
              icon: type.slug,
            })),
          },
          {
            name: 'Status',
            filters: vehicleStatuses,
          },
        ],
  })),
  on(VehicleFiltersActions.setManyVehicleFilters, (state, action) => ({
    ...state,
    selectedFilters: action.filters,
  })),
  on(VehicleFiltersActions.setVehicleSearchByFields, (state, action) => ({
    ...state,
    searchFields: action.searchFields,
  })),
  on(VehicleFiltersActions.setVehiclesFilter, (state, action) => ({
    ...state,
    selectedFilters: state.selectedFilters
      .map((i) => i.id)
      .includes(action.filterItem.id)
      ? state.selectedFilters.filter(
          (filter) => filter.id !== action.filterItem.id,
        )
      : [...state.selectedFilters, action.filterItem],
  })),
);

export const getSortBy = (state: State) => state.sortBy;
export const getVehicleFilters = (state: State) => state.vehicleFilters;
export const getSelectedFilters = (state: State) => state.selectedFilters;
export const getSearchText = (state: State) => state.searchText;
export const getSortByList = (state: State) => state.sortByList;
export const getSearchFields = (state: State) => state.searchFields;
